  <template>
  <div class="historicla">
    <!-- 打印处方 -->
    <div class="mask1" style="display: none">
      <div class="prescription_img_box" style="overflow: scroll">
        <viewer>
          <section ref="print" id="jqImg">
            <img
              v-for="(item, i) in imgUrl"
              :key="i"
              :src="item"
              class="pointer"
            />
          </section>
        </viewer>
      </div>
    </div>
    <!--打印单个历史处方>-->
    <div style="display: none">
      <section ref="printOne">
        <div v-if="showPrint">
          <dom-print
            :InquiryId="InquiryId"
            @afterPrint="afterPrint"
            @beforPrint="beforPrint"
          ></dom-print>
        </div>
      </section>
    </div>
    <!-- 历史处方-->
    <div class="flex2">
      <div class="flex2">
        <div class="fixed_width72">患者姓名：</div>
        <input
          type="text"
          v-model="filterCondition.name"
          style="width: 180px"
        />
      </div>
      <div class="flex2">
        <div class="fixed_width72">手机号码：</div>
        <input
          type="text"
          v-model="filterCondition.mobile"
          style="width: 180px"
        />
      </div>

      <!-- <div class="flex2">
        <label for="inquiry_recording" class="fixed_width72">处方类型：</label>
        <select
          id="inquiry_recording"
          class="select_inquiry_recording"
          v-model="filterCondition.selectModel"
          style="width:180px;"
        >
          <option>全部</option>
          <option>西药处方</option>
          <option>中药处方</option>
        </select>
      </div> -->
      <div class="flex2">
        <div class="fixed_width72">处方日期：</div>
        <Date-picker
          type="daterange"
          split-panels
          placeholder="选择日期"
          :value="filterCondition.createDate"
          style="width: 180px; margin-right: 34px"
          :editable="false"
          @on-change="createDateChange"
        ></Date-picker>
      </div>
      <div class="flex2" v-if="totalShop">
        <div class="fixed_width72">来源门店：</div>
        <!-- <input type="text" v-model="filterCondition.sourceName" style="width:180px;" /> -->
        <select
          id="inquiry_recording"
          class="select_inquiry_recording"
          v-model="filterCondition.ShopId"
          style="width: 180px"
        >
          <option value="0">全部</option>
          <option
            :value="item.ShopId"
            v-for="(item, i) in childStoreList"
            :key="i"
          >
            {{ item.ShopName }}
          </option>
        </select>
      </div>
    </div>

    <div class="flex2 margin_top26 margin_bottom26">
      <div class="flex2">
        <div class="fixed_width72">药品名称：</div>
        <input
          type="text"
          v-model="filterCondition.DrugName"
          style="width: 180px"
        />
      </div>
      <!-- <div class="flex2">
        <div class="fixed_width72">药师审核：</div>
        <select
          @keyup.enter="pressSearch()"
          id="inquiry_recording"
          class="select_inquiry_recording"
          style="width:180px;"
        >
          <option>全部</option>
          <option>已审核</option>
          <option>待审核</option>
        </select>
      </div>
      <div class="flex2">
        <div class="fixed_width72">远程审方：</div>
        <select
          @keyup.enter="pressSearch()"
          id="inquiry_recording"
          class="select_inquiry_recording"
          style="width:180px;"
        >
          <option>全部</option>
          <option>是</option>
          <option>否</option>
        </select>
      </div>-->
      <div class="inquiry_recording_search_btn pointer" @click="pressSearch">
        查询
      </div>
      <div class="print_btn pointer" @click="printInquiryImg">
        批量打印本页处方
      </div>
      <div class="print_btn pointer" @click="batchExport">批量导出图片</div>
      <!-- <div class="inquiry_recording_search_btn pointer" @click="lookPrescription">弹出模态框</div> -->
    </div>

    <!-- <div class="margin_top26 margin_bottom26">
      <div class="flex2" style="margin-left:79%;">
        <div
          class="inquiry_recording_search_btn pointer"
          @click="pressSearch"
          @keyup.enter="pressSearch()"
        >查询</div>
        <div class="print_btn pointer" @click="printInquiryImg">批量打印本页处方</div>
      </div>
    </div>-->
    <!-- 查看处方 -->
    <div class="mask1" v-if="lookShop">
      <look-Prescription
        v-if="lookShop"
        @lookModule="closeModule"
        @noeModules="oneKeySignature"
        :InquiryId="InquiryId"
        v-watermark="{
          text: appMobilePhone,
          textColor: 'rgba(180, 180, 180, 0.3)',
        }"
      ></look-Prescription>
    </div>
    <!-- 一键签名 -->
    <div class="mask1" v-if="oneShop">
      <one-signature
        @noeModules="closeoneModule"
        :InquiryId="InquiryId"
        :PrescriptionStatus="PrescriptionStatus"
        :signaNum="signaNum"
      ></one-signature>
    </div>
    <Table
      :columns="tableColumns"
      :data="tableData"
      border
      style="margin-bottom: 20px"
    ></Table>
    <Page
      :total="PageTotal"
      style="text-align: center"
      @on-change="pageChange"
    />
  </div>
</template>

<script>
import {
  GetInquiryHistoryList,
  DownLoadToBase64,
  GetPicCodeByUrl,
  DownLoadOrderList,
  CreateDownLoadOrderList,
} from "@/utils/api.js";
import domPrint from "@/components/domPrint";
import { getToken, getAge } from "@/utils/common.js";
import lookPrescription from "@/components/lookPrescription";
import oneSignature from "@/components/onekeySignature";
import { Radio, Alert, Divider, Toast } from "iview";
// import "@/src/utils/jquery-1.4.4.min";
import "@/utils/jquery.jqprint-0.3";
export default {
  props: {
    shopTypeChild: {
      type: String,
      default: false,
    },
    childStoreList: {
      default: false,
    },
  },

  components: {
    lookPrescription,
    oneSignature,
    domPrint,
  },
  data() {
    return {
      signaNum: 0,
      PageTotal: 0, // 记录总条数
      page: 1,
      InquiryId: "",
      PrescriptionStatus: "",
      drugPage: 1,
      appMobilePhone: "",
      totalShop: false,
      lookShop: false,
      showPrint: false,
      oneShop: false,
      filterCondition: {
        // 筛选条件
        selectModel: "全部",
        createDate: ["", ""],
        name: "",
        mobile: "",
        ShopId: "0",
        DrugName: "",
      },
      tableColumns: [
        {
          title: "患者姓名",
          key: "Name",
          align: "center",
        },
        {
          title: "性别",
          key: "Sex",
          align: "center",
          width: "80",
          render: (h, params) => {
            let sexChina = params.row.Sex == 1 ? "男" : "女";
            return h("span", sexChina);
          },
        },
        {
          title: "年龄",
          key: "AgeStr",
          align: "center",
        },
        {
          title: "手机号",
          key: "Mobilephone",
          align: "center",
        },
        {
          title: "诊断",
          key: "Diagnosis",
          align: "center",
        },
        {
          title: "处方日期",
          key: "CreateDate",
          align: "center",
          render: (h, params) => {
            var str = params.row.CreateDate;
            if (str.length > 10) {
              var strs = str.split("T")[0];
            } else {
              var strs = str;
            }
            return h("span", strs);
          },
        },
        {
          title: "处方类型",
          key: "type",
          align: "center",
          render: (h, params) => {
            return h("span", "西药处方");
          },
        },
        {
          title: "处方医生",
          key: "DoctorName",
          align: "center",
        },
        {
          title: "药师审核",
          key: "IsPharSign",
          align: "center",
          render: (h, params) => {
            let tmpStr = "";
            if (!params.row.PharAuditNameUrl) {
              tmpStr = "待审方";
            } else {
              tmpStr = "已审方";
            }
            return h(
              "span",
              {
                style: {
                  color: params.row.IsPharSign == false ? "#DB0E0E" : "#515a6e",
                },
              },
              tmpStr
            );
          },
        },
        {
          title: "远程审方",
          key: "AuditStatus",
          align: "center",
          render: (h, params) => {
            let tmpStr = "";
            if (params.row.AuditStatus == null || params.row.AuditStatus == 0) {
              tmpStr = "否";
            } else {
              tmpStr = "是";
            }
            return h("span", tmpStr);
          },
        },
        {
          title: "操作",
          key: "doit",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.lookPrescription(params.row);
                    },
                  },
                },
                "查看处方"
              ),
              // h(
              //   "Button",
              //   {
              //     props: {
              //       type: "text",
              //       size: "small"
              //     },
              //     on: {
              //       click: () => {
              //         this.printPrescription(params.row);
              //       }
              //     }
              //   },
              //   "打印处方"
              // ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.printPrescriptionJq(params.row);
                    },
                  },
                },
                "打印处方"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.savePrescription(params.row);
                    },
                  },
                },
                "保存处方"
              ),
            ]);
          },
        },
      ],
      tableData: [],
      batchUrl: [],
      imgUrl: [],
      DownLoadKey: "",
    };
  },
  methods: {
    //轮询等待下载
    loadingDown() {
      DownLoadOrderList({ DownLoadKey: this.DownLoadKey }).then((res) => {
        if (res.code == 1) {
          console.log(res);
          window.open(process.env.VUE_APP_RELOAD + res.data);
        } else {
          setTimeout(() => {
            this.loadingDown();
          }, 3000);
        }
      });
    },
    //批量导出
    batchExport() {
      CreateDownLoadOrderList({
        StartTime: this.filterCondition.createDate[0],
        EndTime: this.filterCondition.createDate[1],
        Name: this.filterCondition.name,
        Mobilephone: this.filterCondition.mobile,
        ShopId: this.filterCondition.ShopId, //来源门店this.filterCondition.sourceName
        Status: 5,
        ModeType: "",
        DrugName: this.filterCondition.DrugName,
        PageIndex: 1,
        PageSize: 100000,
      }).then((res) => {
        if (res.code == 1) {
          // this.$Modal.warning({
          //   title: "提示",
          //   content: "批量导出图片生成中",
          // });
          this.$Notice.warning({
            title: "提示",
            desc: "批量导出图片生成中",
          });
          this.DownLoadKey = res.data;
          this.loadingDown();
        } else {
          this.$Modal.warning({
            title: "提示",
            content: res.msg,
          });
        }
      });
    },
    //一键签名
    oneKeySignature(e) {
      this.signaNum = e;
      this.lookShop = !this.lookShop;
      this.oneShop = !this.oneShop;
    },
    closeoneModule() {
      this.oneShop = !this.oneShop;
      this.lookShop = !this.lookShop;
    },
    //关闭弹框
    closeModule() {
      this.lookShop = !this.lookShop;
    },
    //查看处方
    lookPrescription(row) {
      this.InquiryId = row.LoInquiryId;
      this.PrescriptionStatus = row.PrescriptionStatus;
      this.lookShop = !this.lookShop;
    },
    //单个打印处方
    printPrescription(row) {
      if (row.OrderFileUrl) {
        var url = row.OrderFileUrl;
        this.imgUrl = [url];
        console.log(this.imgUrl);
        let t1 = setTimeout((res) => {
          this.$print(this.$refs.print); // 使用
          window.clearInterval(t1);
        });
      } else {
        this.$Modal.warning({
          title: "提示",
          content: "该历史处方无处方图片,打印失败！",
        });
      }
    },
    //单个打印图片jq
    printPrescriptionJq(row) {
      if (row.OrderFileUrl) {
        this.InquiryId = row.LoInquiryId;
        this.showPrint = true;
      } else {
        this.$Modal.warning({
          title: "提示",
          content: "该历史处方无处方图片,打印失败！",
        });
      }
    },
    //获取完数据之后打印处方
    afterPrint() {
      let t1 = setTimeout((res) => {
        this.$print(this.$refs.printOne); // 使用
        this.showPrint = false;
        window.clearInterval(t1);
      });
    },
    //获取处方失败
    beforPrint() {
      this.showPrint = false;
    },
    //保存处方
    savePrescription(row) {
      var msg = {
        url: row.OrderFileUrl,
        id: row.InquiryId,
        base64: true,
      };
      this.$store.dispatch("downloads", msg);
    },
    // 批量打印处方
    printInquiryImg() {
      if (this.batchUrl[0] === undefined || this.batchUrl.length == 0) {
        this.$Modal.warning({
          title: "提示",
          content: "本页表格暂无数据，批量打印处方失败！！",
        });
        return false;
      }
      this.imgUrl = this.batchUrl;
      let t1 = setTimeout((res) => {
        // this.$print(this.$refs.print); // 使用
        $("#jqImg").jqprint({
          debug: false,
          importCSS: false,
          printContainer: true,
          operaSupport: false,
        });
        // window.clearInterval(t1);
      });
    },
    pageChange(i) {
      console.log(i);
      this.page = i;
      this.getHistory();
    },
    //选择日期触发条件
    createDateChange(value) {
      this.filterCondition.createDate = value;
    },
    //点击查询按钮
    pressSearch() {
      this.page = 1;
      this.getHistory();
    },
    //获取历史处方
    getHistory() {
      // const msg = this.$Message.loading({
      //   content: "加载中",
      //   duration: 0
      // });
      let UserId = localStorage.getItem("app_mobile");
      let companyName = localStorage.getItem("companyName");
      let Token = localStorage.getItem("hToken");
      let ShopType = this.shopTypeChild;
      // let ModeTypeTest =
      //   this.filterCondition.selectModel == "全部"
      //     ? ""
      //     : this.filterCondition.selectModel == "西药处方"
      //     ? 2
      //     : 1;
      GetInquiryHistoryList({
        StartTime: this.filterCondition.createDate[0],
        EndTime: this.filterCondition.createDate[1],
        Name: this.filterCondition.name,
        Mobilephone: this.filterCondition.mobile,
        ShopId: this.filterCondition.ShopId, //来源门店this.filterCondition.sourceName
        Status: 5,
        ModeType: "",
        DrugName: this.filterCondition.DrugName,
        PageIndex: this.page,
        PageSize: 10,
      }).then((res) => {
        // setTimeout(msg, 17);
        if (res.code == 1) {
          this.tableData = [];
          this.batchUrl = [];
          this.PageTotal = res.data.total;
          this.tableData = res.data.list;
          res.data.list.map((item) => {
            // item.PharmacistStatus = 99;
            this.batchUrl.push(item.OrderFileUrl);
          });
        } else {
          this.$Modal.warning({
            title: "提示",
            content: res.msg,
          });
        }
        this.loading = false;
      });
    },
    weekTime() {
      const myDate = new Date();
      const year = myDate.getFullYear(); // 获取当前年份
      const month =
        myDate.getMonth() + 1 < 10
          ? "0" + (myDate.getMonth() + 1)
          : myDate.getMonth() + 1; // 获取当前月份(0-11,0代表1月所以要加1);
      const day =
        myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate(); // 获取当前日（1-31）
      // 日期格式：2019/07/29 - 2019/07/29
      const lastDate = new Date(new Date() - 6 * 24 * 60 * 60 * 1000);

      const lastYear = lastDate.getFullYear(); // 获取当前年份
      const lastMonth =
        lastDate.getMonth() + 1 < 10
          ? "0" + (lastDate.getMonth() + 1)
          : lastDate.getMonth() + 1; // 获取当前月份(0-11,0代表1月所以要加1);
      const lastDay =
        lastDate.getDate() < 0 ? "0" + lastDate.getDate() : lastDate.getDate(); // 获取当前日（1-31）
      this.$nextTick(() => {
        this.filterCondition.createDate = [
          `${lastYear}-${lastMonth}-${lastDay}`,
          `${year}-${month}-${day}`,
        ];
        console.error(this.filterCondition.createDate);
        this.getHistory();
      });
    },
  },
  mounted() {
    setTimeout((res) => {
      this.weekTime();
    });

    this.appMobilePhone = localStorage.getItem("app_mobile");

    if (this.shopTypeChild == 0) {
      let comObg = {
        title: "来源门店",
        key: "CompanyName",
        align: "center",
      };
      this.totalShop = true;
      this.tableColumns.splice(6, 0, comObg);
    } else {
      if (this.tableColumns.length == 10) {
        this.totalShop = false;
        this.tableColumns.splice(7, 1);
      }
    }
  },
  created() {
    // this.keyupEnter();
  },
};
</script>
<style lang="scss">
.print_btn {
  height: 28px;
  padding: 0 15px;
  background: #2f318b;
  border-radius: 4px;
  text-align: center;
  line-height: 28px;
  color: white;
  line-height: 28px;
  margin-left: 20px;
}
</style>
<style lang="scss" scoped src="../scss/index.scss"></style>